import React from "react";
import "./expertise.scss";
import Img1 from "../../../assets/Group 154.svg";
import Img2 from "../../../assets/Frame 1000004587.svg";
import Img3 from "../../../assets/charity.svg";
import Img4 from "../../../assets/business-monitoring.svg";
import Img5 from "../../../assets/career-performance.svg";
import Img6 from "../../../assets/review.svg";
import Img7 from "../../../assets/management.svg";
import Img8 from "../../../assets/service.svg";
import { Zoom,Slide } from "react-awesome-reveal";

const Expertise = () => {
  return (
    <div className="expertise pt-5" id="exp">
      <div className="container">
        <div className="expertise-title">
           <Zoom>
          <h3>Our Expertise</h3>
           </Zoom>
        </div>
        <div className="expertise-content">
          <Slide>
          <div className="row rows-col-4">
            <div className="col-lg-3 col-md-6">
              <div className="expertise-parts position-relative">
                <img src={Img1} alt="" />
                <span>Restructuring And Debt Solution</span>
                <p>
                  Assisting lenders to determine option to solve stress via
                  restructuring , sale to Arc, and sale of assets
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="expertise-parts">
                <img src={Img2} alt="" />

                <span>Sell And Buy Advisory</span>
                <p>
                  Assisting lenders to find a buyer for 51% + shareholding in
                  the company, non-core assets.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="expertise-parts">
                <img src={Img3} alt="" />

                <span>Funding</span>
                <p>
                  Funding of distressed asset, acquisitions &amp; turnaround.
                  Project funding, Growth funding
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="expertise-parts">
                <img src={Img4} alt="" />

                <span>Asset Specialized &amp; Monitoring</span>
                <p>
                  Assisting banks in monitoring the account performance and
                  achievement milestones.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="expertise-parts">
                <img src={Img5} alt="" />

                <span>Independent Business Review</span>
                <p>Assisting lenders to determine viability of business</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="expertise-parts">
                <img src={Img6} alt="" />

                <span>Performance Improvement</span>
                <p>
                  Analysis of operational efficiency &amp; cost reduction
                  program
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="expertise-parts">
                <img src={Img7} alt="" />

                <span>Interim Management / ASM</span>
                <p>
                  Professional management to run the aﬀairs of the company till
                  divested
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="expertise-parts">
                <img src={Img8} alt="" />

                <span>Insolvency Service &amp; Advisory</span>
                <p>
                  End to end services in resolving cases under IBC Forensic
                  audit Transaction Audit Serves
                </p>
              </div>
            </div>
            {/* Add more expertise cards here if needed */}
          </div>
          </Slide>
        </div>
      </div>
    </div>
  );
};

export default Expertise;
